import moment from 'moment';
import * as React from 'react';
import { Container, Divider, Modal, Segment } from 'semantic-ui-react';

import { clienteApi, Resultados } from 'src/api';
import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';
import { Contexto } from 'src/contexto';
import { nombreCompletoConNombresPrimero } from 'src/utilidades';
import { FormularioDeIngreso, IngresoAtencion } from './componentes/FormularioDeIngreso';
import { TablaDeAtenciones } from './componentes/TablaDeAtenciones';

interface State {
    alumnos: ReadonlyArray<{
        numeroDeMatricula: number;
        nombre: string;
    }>;
    mapaAlumnos: Map<number, string>;
    atenciones: Resultados<'atencionesPsicopedagogiaDeFecha'>;
    cargando: boolean;
    cargandoAtenciones: boolean;
    eliminandoAtencion: string | undefined;
    fechaDeAtenciones: string;
}

const stateInicial: State = {
    alumnos: [],
    mapaAlumnos: new Map<number, string>(),
    atenciones: [],
    cargando: true,
    cargandoAtenciones: true,
    eliminandoAtencion: undefined,
    fechaDeAtenciones: moment()
        // TODO: Esto no estoy seguro de si está bien. Preguntarle a Daniel
        .format('YYYY-MM-DD')
        .toString(),
};

class Psicopedagogia extends React.Component<{}, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = stateInicial;

    public async componentDidMount() {
        this.actualizarListas();
    }

    public render() {
        return (
            <Container>
                {this.state.eliminandoAtencion && (
                    <ModalEliminacion
                        alCerrar={() => this.setState({ eliminandoAtencion: undefined })}
                        alConfirmar={this.eliminarAtencion}
                    />
                )}
                <Segment>
                    <FormularioDeIngreso
                        cargando={this.state.cargando}
                        alumnos={this.state.alumnos}
                        alIngresar={this.registrarAtencion}
                    />
                </Segment>
                <Segment>
                    <TablaDeAtenciones
                        atenciones={this.state.atenciones}
                        mapaAlumnos={this.state.mapaAlumnos}
                        cargandoAtenciones={this.state.cargandoAtenciones}
                        fechaDeAtenciones={this.state.fechaDeAtenciones}
                        alSolicitarAtenciones={fecha => this.obtenerAtenciones(fecha)}
                        alEliminar={idAtencion => this.setState({ eliminandoAtencion: idAtencion })}
                    />
                </Segment>
                <Divider hidden />
            </Container>
        );
    }

    private readonly registrarAtencion = async (datos: IngresoAtencion) => {
        if (datos.ausente === true) {
            return clienteApi
                .ejecutar('ingresarAtencionPsicopedagogia', {
                    numeroDeMatricula: datos.numeroDeMatricula,
                    fechaYHora: datos.fechaYHora,
                    presente: false,
                })
                .then(this.actualizarListas)
                .catch(this.context.mostrarModalError);
        }
        return clienteApi
            .ejecutar('ingresarAtencionPsicopedagogia', {
                numeroDeMatricula: datos.numeroDeMatricula,
                fechaYHora: datos.fechaYHora,
                presente: true,
                excepcional: datos.excepcional,
            })
            .then(this.actualizarListas)
            .catch(this.context.mostrarModalError);
    };

    private readonly actualizarListas = () => {
        Promise.all([this.obtenerListaDeAlumnos(), this.obtenerAtenciones()])
            .then(() => this.setState({ cargando: false, cargandoAtenciones: false }))
            .catch(this.context.mostrarModalError);
    };

    private readonly obtenerListaDeAlumnos = async () => {
        return clienteApi
            .ejecutar('listaDeAlumnos')
            .then(resultados => {
                const resultadoAlumnos = resultados.alumnos
                    .map(a => ({ ...a, nombre: nombreCompletoConNombresPrimero(a.nombre) }))
                    .sort((a, b) => a.nombre.localeCompare(b.nombre));

                const alumnos = resultadoAlumnos.map(alumno => ({
                    numeroDeMatricula: alumno.numeroDeMatricula,
                    nombre: alumno.nombre,
                }));

                const mapaAlumnos = new Map<number, string>();
                for (const alumno of alumnos) {
                    mapaAlumnos.set(alumno.numeroDeMatricula, alumno.nombre);
                }
                this.setState({ cargando: true, alumnos, mapaAlumnos });
            })
            .catch(this.context.mostrarModalError);
    };

    private readonly obtenerAtenciones = async (fecha?: string) => {
        if (fecha !== undefined) {
            this.setState({ fechaDeAtenciones: fecha });
        }
        return clienteApi
            .ejecutar(
                'atencionesPsicopedagogiaDeFecha',
                fecha === undefined ? this.state.fechaDeAtenciones : fecha,
            )
            .then(resultados => {
                this.setState({ cargandoAtenciones: true, atenciones: resultados });
            })
            .finally(() => this.setState({ cargandoAtenciones: false }))
            .catch(this.context.mostrarModalError);
    };

    private readonly eliminarAtencion = () => {
        if (!this.state.eliminandoAtencion) return;

        clienteApi
            .ejecutar('eliminarAtencionPsicopedagogia', this.state.eliminandoAtencion)
            .then(() => this.obtenerAtenciones())
            .then(() => this.setState({}))
            .catch(this.context.mostrarModalError);
    };
}

const ModalEliminacion = (props: { alConfirmar(): void; alCerrar(): void }) => (
    <ModalEnfocable open closeIcon onClose={props.alCerrar}>
        <Modal.Header content='¿Está seguro que quiere eliminar esta atención?' />
        <Modal.Content content='Esta acción no se puede deshacer' />
        <Modal.Actions
            actions={[
                { key: 'no', content: 'No', onClick: props.alCerrar },
                {
                    key: 'si',
                    content: 'Sí',
                    negative: true,
                    onClick: () => {
                        props.alConfirmar();
                        props.alCerrar();
                    },
                },
            ]}
        />
    </ModalEnfocable>
);

export default Psicopedagogia;



// WEBPACK FOOTER //
// ./src/modulos/Psicopedagogia/index.tsx